"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTab = void 0;
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
var createMuiTab = function (theme) {
    var _a, _b;
    return ({
        styleOverrides: {
            root: {
                textTransform: "none",
                color: colors_1.colors.Text,
                fontSize: global_1.typography.regular16.fontSize,
                "&": (_a = {},
                    _a[theme.breakpoints.down("md")] = {
                        paddingLeft: 0,
                        paddingRight: 0,
                    },
                    _a.paddingLeft = theme.spacing(5),
                    _a.paddingRight = theme.spacing(5),
                    _a),
                "&.Mui-selected": {
                    color: colors_1.colors.Text,
                    fontWeight: global_1.typography.fontWeightBold,
                },
                "& .MuiBadge-badge": (_b = {},
                    _b[theme.breakpoints.down("md")] = {
                        top: "-10px",
                        marginLeft: "5px",
                        position: "relative",
                        right: 0,
                        transform: "none",
                    },
                    _b.top = "3px",
                    _b.right = "-16px",
                    _b),
            },
        },
    });
};
exports.createMuiTab = createMuiTab;
//# sourceMappingURL=tab.js.map